import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';

@Component({
    selector: 'timec',
    templateUrl: 'timec.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class TimecComponent implements OnChanges {
  @Input() iso: string; // ISO8601
  @Input() rfc: string; // RFC850

  ngOnChanges() {
    this.iso = this.iso?.replace(/\s/g, 'T');
    this.rfc = this.rfc?.replace(/\s/g, 'T');
  }
}
